import selectLocalExercise from './selectLocalExercise';
const selectLostXp = (state, id) => {
  const localExercise = selectLocalExercise(state, id);
  if (localExercise === undefined) {
    return 0;
  }
  return localExercise.lostXp;
};
export default selectLostXp;